(function () {
  "use strict";

  function focusableElements(container) {
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.getAttribute("aria-hidden") !== "true";
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.drsknnCredentialReady === "true") return;
    root.dataset.drsknnCredentialReady = "true";

    var modal = root.querySelector("[data-drsknn-credential-modal]");
    var dialog = root.querySelector("[data-drsknn-credential-dialog]");
    var closeButton = root.querySelector("[data-drsknn-credential-close]");
    var panels = Array.from(root.querySelectorAll("[data-drsknn-credential-panel]"));
    var opener = null;
    var closeTimer = null;

    if (!modal || !dialog || !closeButton || !panels.length) return;

    function setPanel(key) {
      var activePanel = null;
      panels.forEach(function (panel) {
        var active = panel.getAttribute("data-drsknn-credential-panel") === key;
        panel.hidden = !active;
        if (active) activePanel = panel;
      });
      if (activePanel) {
        var heading = activePanel.querySelector("h3");
        if (heading && heading.id) dialog.setAttribute("aria-labelledby", heading.id);
      }
    }

    function openModal(key, trigger) {
      if (closeTimer) window.clearTimeout(closeTimer);
      opener = trigger || document.activeElement;
      setPanel(key);
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("drsknn-credential-lock");
      window.requestAnimationFrame(function () {
        modal.classList.add("is-open");
        dialog.focus({ preventScroll: true });
      });
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("drsknn-credential-lock");
      closeTimer = window.setTimeout(function () {
        modal.hidden = true;
        if (opener && typeof opener.focus === "function") opener.focus({ preventScroll: true });
      }, 180);
    }

    root.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-drsknn-credential-open]");
      if (trigger && root.contains(trigger)) {
        openModal(trigger.getAttribute("data-drsknn-credential-open"), trigger);
        return;
      }
      if (event.target === modal || event.target.closest("[data-drsknn-credential-close]")) closeModal();
    });

    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = focusableElements(dialog);
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    document.querySelectorAll("[data-drsknn-credential-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
  document.addEventListener("shopify:section:load", init);
})();
